import { useStore } from '@nanostores/react'
import { AnimatePresence } from 'motion/react'
import { motion } from '~/lib/motion'
import { Portal } from 'radix-ui'
import { $rewardFlowState } from '~/features/reward-flow/store'
import { BalanceBar } from './components/balance-bar'
import { MainContent } from './components/main-content'
import { PreviewAnim } from './components/preview-anim'
import { useBalanceQuery } from './hooks/use-balance-query'

export function RewardFlow({ background }: { background?: string }) {
  useBalanceQuery()
  const state = useStore($rewardFlowState)
  const items = state.items
  const previewAnim = state.previewAnim
  const currentIndex = state.currentIndex
  const item = items?.[currentIndex]
  return (
    <Portal.Root asChild>
      <AnimatePresence>
        {items && (
          <motion.div
            className="fixed inset-0 z-[100] flex flex-col"
            style={{ background }}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.3,
                ease: [0.33, 1, 0.68, 1],
              },
            }}
            exit={{
              opacity: 0,
              transition: {
                duration: 0.15,
                ease: [0.32, 0, 0.67, 0],
              },
            }}
          >
            {/* Balance bar - outside AnimatePresence to persist across item transitions */}
            {!previewAnim && (
              <div className="mx-auto flex w-full max-w-[640px] justify-end px-6 pb-[10px] pt-[calc(8px+var(--safe-area-top))]">
                <BalanceBar />
              </div>
            )}
            <AnimatePresence mode="wait" initial={false}>
              {previewAnim ? (
                <PreviewAnim key="preview-anim" state={previewAnim} />
              ) : (
                item && (
                  <MainContent
                    key={currentIndex}
                    item={item}
                    items={items}
                    currentIndex={currentIndex}
                  />
                )
              )}
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
    </Portal.Root>
  )
}
